import { Controller } from "@hotwired/stimulus"

// Manages a reorderable list of asset links (image/video URLs) inside the
// entry edit form, serializing them into a single hidden JSON field on submit.
export default class extends Controller {
  static targets = ["list", "row", "template", "output"]

  connect() {
    this.syncOutput()
  }

  add(event) {
    event.preventDefault()
    const html = this.templateTarget.innerHTML.replace(/__INDEX__/g, Date.now())
    this.listTarget.insertAdjacentHTML("beforeend", html)
    this.syncOutput()
  }

  remove(event) {
    event.preventDefault()
    event.target.closest("[data-asset-links-target='row']").remove()
    this.syncOutput()
  }

  preview(event) {
    const row = event.target.closest("[data-asset-links-target='row']")
    const img = row.querySelector("[data-asset-links-target='previewImage']")
    const placeholder = row.querySelector("[data-asset-links-target='previewPlaceholder']")
    const url = event.target.value.trim()

    if (url) {
      img.src = url
      img.classList.remove("hidden")
      placeholder.classList.add("hidden")
    } else {
      img.classList.add("hidden")
      placeholder.classList.remove("hidden")
    }

    this.syncOutput()
  }

  moveUp(event) {
    event.preventDefault()
    const row = event.target.closest("[data-asset-links-target='row']")
    const previous = row.previousElementSibling
    if (previous) row.parentElement.insertBefore(row, previous)
    this.syncOutput()
  }

  moveDown(event) {
    event.preventDefault()
    const row = event.target.closest("[data-asset-links-target='row']")
    const next = row.nextElementSibling
    if (next) row.parentElement.insertBefore(next, row)
    this.syncOutput()
  }

  syncOutput() {
    const urls = this.rowTargets
      .map((row) => row.querySelector("input[type='url']").value.trim())
      .filter((url) => url.length > 0)

    this.outputTarget.value = JSON.stringify(urls)
  }
}
